<template>
<div class="Signer-container mb-2 bg-white">
  <div>
    <font-awesome-icon :icon="['fas', 'grip-vertical']" class="Signer-grabIcon mr-2 text-originalGrey-lighten-1" />
    {{signer.fullName}}
  </div>
  {{index}}

</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'

export default defineComponent({
  name: 'SignersOrderQualifiedSigner',
  props: {
    signerId: {
      type: Number,
      required: true,
    },
    index: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    ...mapGetters('groups', ['allRoomMembers']),
    signer () {
      return this.allRoomMembers.find((member: ObjectWith<{ id: number }>) => member.id === this.signerId)
    },
  },
})
</script>

<style scoped lang="scss">
.Signer {
  &-container {
    border: 1px solid #E9ECEF;
    border-radius: 4px;
    padding: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &-grabIcon {
    cursor: grab;
  }
}
</style>
